import _ from 'lodash'
import itemMixins from './itemMixins'
import menuMixins from './menuMixins'
import { CollapseTransition } from '../transition'
import Icon from '../icon'
import Popover from '../popover'
import { convertPropClass2ClassObjectLike } from '../../core/utils/KProps'

export default {
  name: 'KSubMenu',
  mixins: [itemMixins, menuMixins],
  inject: ['menu'],
  props: {
    // 默认是否展开（如果是accordion=true，则此属性无效）
    defaultExpand: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubMenu: true,
      expand: false,
      popperVisible: false,
    }
  },
  computed: {
    popperClass() {
      return this.menu.popperClass
    },
    accordionMode() {
      return this.menu.accordion
    },
  },
  watch: {
    hasActiveItem(val) {
      if (val) {
        this.$nextTick(() => {
          this.expand = true
        })
      }
    },
    expand(val) {
      if (!val) {
        return
      }

      if (!this.accordionMode) {
        return
      }

      const parent = this.parent
      if (parent) {
        _.forEach(parent.children || [], child => {
          if (child.$options && child.$options.name === 'KSubMenu' && child !== this) {
            child.expand = false
          }
        })
      }
    },
  },
  created() {
    if (!this.accordion && this.defaultExpand) {
      this.expand = true
    }
  },
  methods: {
    getRenderData() {
      const style = {}

      const css = {
        'km-menu__item--expand': this.showSubMenuInPopper ? this.popperVisible : this.expand,
        'km-menu__item--has-active': this.hasActiveItem,
      }

      const attrs = {}

      const props = {}

      const events = {}

      const data = {
        style: style,
        class: css,
        attrs: attrs,
        props: props,
        on: events,
      }

      return data
    },
    handleTitleClick() {
      if (!this.showSubMenuInPopper) {
        this.expand = !this.expand
      }
    },
    renderToggle() {
      // if (this.collapsed) {
      //   return null
      // }

      const css = {
        'km-menu__toggle': true,
        'km-menu__toggle--expand': !this.showSubMenuInPopper && this.expand,
      }

      return (
        <div class={css}>
          <Icon name="angle-right"></Icon>
        </div>
      )
    },
    renderReference() {
      const should = this.mode === 'popper' && this.level === 0 && this.collapsed
      if (!should) {
        return null
      }
      return (
        <div class="km-menu__popper-title">
          {this.$slots.title}
        </div>
      )
    },
    renderPopperSubMenu() {
      return (
        <Popover
          value={this.popperVisible}
          placement="right-start"
          trigger="hover"
          arrow={false}
          popperClass={{
            'km-menu__popper': true,
            [`km-menu__popper--level-${this.level}`]: true,
            ...convertPropClass2ClassObjectLike(this.popperClass),
          }}
          onInput={value => {
            this.popperVisible = value
          }}
        >
          {this.renderTitle()}
          <div>
            {this.renderReference()}
            {this.$slots.default}
          </div>
        </Popover>
      )
    },
    renderSubMenu() {
      if (!this.isSubMenu) {
        return null
      }

      return (
        <CollapseTransition>
          <div v-show={this.expand}>
            {this.$slots.default}
          </div>
        </CollapseTransition>
      )
    },
  },
}
